// extracted by mini-css-extract-plugin
export default {"a":"link_a__FHbqP","button":"link_button__LUCR7"};